module.exports = __webpack_public_path__ + "12e39ccb1cbd719698ce97f194661a95.png";